import { ComfortSeatConflict } from '@/new-transport/_models/transport.model';

/**
 * Builds a user-facing (Polish) message listing comfort package seat conflicts that need seat reassignment.
 *
 * @param header - First line of the message describing the context of the conflicts.
 * @param conflicts - List of {@link ComfortSeatConflict} returned by the backend.
 * @returns HTML message with one conflict per line, or an empty string when there are no conflicts.
 */
export function formatComfortSeatConflicts(
	header: string,
	conflicts: ComfortSeatConflict[] | null | undefined,
): string {
	if (!conflicts?.length) {
		return '';
	}

	const lines = conflicts.map((conflict) => {
		const layout = conflict.layout ? ` (${conflict.layout})` : '';
		return `Rezerwacja ${conflict.reservationId}, transport ${conflict.transportId}, miejsce ${conflict.seatNumber ?? '-'}${layout}`;
	});

	return [header, ...lines].join('<br>');
}
